// src/hooks/useOffers/useOffers.js
import { publicRqClient } from "../../shared/api/instance";

export function useGetOffers({ region }, { enabled = true } = {}) {
  return publicRqClient.useQuery(
    "get",
    "/events/v1/offers",
    {
      params: {
        query: {
          region,
        },
      },
    },
    {
      enabled,
      staleTime: 1000 * 60 * 30, // 30 minutes cache
    }
  );
}
